
import React, {useCallback, useEffect, useState} from "react";
import axios from "axios";
import apiUrl from "../../shared/config";
import {useDispatch, useSelector} from "react-redux";
import classes from './NotificationPanel.module.css'
import {AccordionCollapse, AccordionToggle} from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import Row from "react-bootstrap/Row";
import {NavLink} from "react-router-dom";
import Button from "react-bootstrap/Button";
import * as actionTypes from "../../store/actions/actionTypes";
import {PriorityHigh} from "@material-ui/icons";
import Form from "react-bootstrap/Form";
import Checkbox from "@material-ui/core/Checkbox";


export default function NotificationPanel() {

    const [notifications, setNotifications] = useState([])
    const [contactEmail, setContactEmail] = useState("")
    const [sharedContactEmail, setSharedContactEmail] = useState(0)

    const token = useSelector(state => state.auth.token);
    const userId = useSelector(state => state.auth.userId);
    const state_notifications = useSelector(state => state.auth.notifications);

    const dispatch = useDispatch();


    const setNotificationState = useCallback(() => {
        setNotifications((state_notifications.notifications ?? []))
    }, [state_notifications]);


    useEffect(() => {
        setNotificationState();
    }, [token, setNotificationState]);


    const formatDate = (dateText) => {
        let date = new Date(dateText);
        if (date.getDate() === new Date().getDate()
            && date.getMonth() === new Date().getMonth()
            && date.getFullYear() === new Date().getFullYear()) {
            return date.toLocaleTimeString('default', { hour: "numeric", minute: "2-digit", hour12: true});
        } else {

            return date.toLocaleString('default', { month: 'short' }) + " " + date.getUTCDate();
        }
    }

    const handleViewNotification = (notif) => {
        if (!notif.hasBeenViewed) {
            if (notif.pattern_id) {
                axios.post(apiUrl + 'Users/deleteUserNotification?token=' + token, notif)
                    .then(r => {
                    }) //console.log("Successfully delete notification")
                    .catch(e => console.log("Failed to delete notification"))

                const viewedNotif = {
                    ...notif,
                    hasBeenViewed: true
                }

                let updated_notifications = notifications.map((notification) => {
                    if (!(notification.pattern_id === notif.pattern_id
                        && notification.game_id === notif.game_id
                        && notification.primary_game_id === notif.primary_game_id
                        && notification.secondary_game_id === notif.secondary_game_id
                        && notification.comment_id === notif.comment_id
                        && notification.element_type === notif.element_type)) {
                        return notification;
                    } else {
                        return viewedNotif;
                    }
                })

                if (updated_notifications) {
                    setNotifications(updated_notifications)
                    dispatch({type: actionTypes.UPDATE_NOTIFICATIONS,
                        value: {
                            notifications: updated_notifications,
                            fetched_timestamp: state_notifications.fetched_timestamp,
                            hidden_content: state_notifications.hidden_content,
                            no_contact_email_content: state_notifications.no_contact_email_content
                        }
                    });
                }
            }
        }

    }

    const handleViewAllNotifications = () => {
        if (notifications) {
            axios.post(apiUrl + 'Users/deleteUserNotifications?token=' + token)
                .then(r => {})//console.log("Successfully delete notifications"))
                .catch(e => console.log("Failed to delete notifications"))
            
            let updated_notifications =
                notifications.map((notif) => {
                        return {
                            ...notif,
                            hasBeenViewed: true
                        }
                    }
                )
            setNotifications(updated_notifications)
            dispatch({type: actionTypes.UPDATE_NOTIFICATIONS, value: {notifications: updated_notifications, fetched_timestamp: state_notifications.fetched_timestamp, hidden_content: state_notifications.hidden_content, no_contact_email_content: state_notifications.no_contact_email_content}});
        }
    }

    const handleUpdateContactEmail = () => {
        let data = {};
        axios.get(apiUrl + "Users/getUserById?user_id=" + userId + "&token=" + token)
            .then(response => {
                console.log('Get successful:', response.data);
                data = response.data;
                data['user_contact_email'] = contactEmail;
                data['share_contact_email'] = sharedContactEmail;
                axios.post(apiUrl + "Users/set?token=" + token, data)
                    .then(response => {
                        console.log('Post successful:', response.data);
                    }).catch(error => {
                    console.error('There was an error setting contact email data!', error);
                });
            }).catch(error => {
            console.error('There was an error fetching contact email data!', error);
        });
    }

    const handleUserContactEmailInfo = () => {

        axios.get(apiUrl + "Users/getUserById?user_id=" + userId + "&token=" + token)
            .then(response => {
                console.log('Get successful:', response.data);
                setContactEmail(response.data.user_contact_email)
                setSharedContactEmail(response.data.share_contact_email)
            }).catch(error => {
                console.error('There was an error fetching contact email data!', error);
            });
    }

    const primary_notif_header = (notif) => {
        return <React.Fragment>Suggestion: <b>{notif.primary_game_name}</b> under <b>{notif.pattern_name}</b></React.Fragment>
    }

    const primary_notif_body = (notif) => {
        return <React.Fragment>
            Under your pattern, <b>{notif.pattern_name}</b>, {notif.display_name} suggested the
            example game <b>{notif.primary_game_name}</b> with the following description:<br/><hr style={{margin: 3}}/>
            <div style={{textIndent: 15}}>{notif.example_description}</div>
        </React.Fragment>
    }
    const secondary_notif_header = (notif) => {
        return <React.Fragment>Suggestion: <b>{notif.secondary_game_name}</b> under <b>{notif.pattern_name}</b></React.Fragment>
    }

    const secondary_notif_body = (notif) => {
        return <React.Fragment>
            Under your pattern, <b>{notif.pattern_name}</b>, {notif.display_name} suggested <b>{notif.secondary_game_name}</b> as
            a secondary example to <b>{notif.primary_game_name}</b>, which has the following description:<br/><hr style={{margin: 3}}/>
            <div style={{textIndent: 15}}>{notif.example_description}</div>
        </React.Fragment>
    }
    const comment_notif_header = (notif) => {
        return <React.Fragment>Comment: <b>{notif.display_name}</b> commented under <b>{notif.pattern_name}</b></React.Fragment>
    }

    const comment_notif_body = (notif) => {
        return <React.Fragment>
            Under your pattern, <b>{notif.pattern_name}</b>, {notif.display_name} added the following
            comment:<br/><hr style={{margin: 3}}/>
            <div style={{textIndent: 15}}>{notif.comment}</div>
        </React.Fragment>
    }

    const rating_notif_header = (notif) => {
        let type = 'n/a';
        if (notif.primary_game_id) {
            type = "example game"
        } else if (notif.comment_id) {
            type =  "comment"
        } else if (notif.pattern_id) {
            type =  "pattern"
        }

        let whose = !notif.primary_game_id || !notif.is_pattern_author ? "your" : "an"
        let is_your_pattern = notif.is_pattern_author && notif.primary_game_id ? " under your pattern," : (notif.primary_game_id || notif.comment_id ? " under" : ",")

        return <React.Fragment>Rating: <b>{notif.vote_count} vote{notif.vote_count === 1 ? '' : 's'}</b> on {whose} {type}{is_your_pattern} <b>{notif.pattern_name}</b></React.Fragment>
    }

    const rating_notif_body = (notif) => {
        let type = 'n/a';
        if (notif.primary_game_id) {
            if (notif.secondary_game_id) {
                type = "secondary example"
            } else {
                type = "example game"
            }
        } else if (notif.comment_id) {
            type =  "comment"
        } else if (notif.pattern_id) {
            type =  "pattern"
        }

        let whose_pattern = 'Your'
        if (type !== 'pattern') {
            whose_pattern = 'Under '
            if (notif.is_pattern_author) {
                whose_pattern += 'your'
            } else {
                whose_pattern += 'the'
            }
        }

        let whose_element = ''
        if (type !== 'pattern') {
            if (!notif.is_pattern_author || type === 'comment') {
                whose_element = 'your'
                if (type === 'comment') {
                    whose_element += ' following'
                }
            } else {
                whose_element = 'the'
            }
        }

        // Formatting Key
        // Pattern: Your pattern, {pattern_name}, received # positive rating(s) (another/other) user(s)!
        // Primary Example: Under (your/the) pattern, {pattern_name}, (your/the) example game {primary_game_name} received # positive rating(s) (another/other) user(s)!
        // Secondary Example: Under (your/the) pattern, {pattern_name}, (your/the) secondary example {secondary_game_name} for example game {primary_game_name} received # positive rating(s) (another/other) user(s)!
        // Comment: Under (your/the) pattern, {pattern_name}, your following comment received # positive rating(s) (another/other) user(s): {comment}

        return <React.Fragment>
            {whose_pattern} pattern, <b>{notif.pattern_name}</b>, {whose_element} {type === 'pattern' ? '' : type}
            {notif.secondary_game_id ? <> <b>{notif.secondary_game_name}</b> for example game </> : ''}
            {notif.primary_game_id ? <b> {notif.primary_game_name}</b> : ''} received <b>{notif.vote_count}</b> positive
            rating{notif.vote_count === 1 ? ' from another user' : 's from other users'}
            {type === 'comment'
                ? <>:<br/>
                    <hr style={{margin: 3}}/>
                    <div style={{textIndent: 15}}>{notif.comment}</div>
                </>
                : '!'}
        </React.Fragment>
    }

    // // These are no longer needed since only the perpetual hidden content notification appears in the on-site notifs
    // const hidden_content_notif_header = (notif) => {
    //     return <React.Fragment>Hidden Content: <b>{notif.pattern_name}</b> has hidden content</React.Fragment>
    // }
    //
    // const hidden_content_notif_body = (notif) => {
    //     return <React.Fragment>
    //         Under your pattern, <b>{notif.pattern_name}</b>, there is content being hidden from other users on the site
    //          due to a contributing user removing or unsharing their contact email. {hidden_content_text(notif, false)} {notif.hidden_pattern
    //         ? "You can share your contact email to make this pattern visible again. Once you do so, you'll have the ability" +
    //         " to make other hidden content visible again by verifying it with a like."
    //         : "If you have a shared contact email, you can verify this content by liking it, which will make it visible."}
    //     </React.Fragment>
    // }

    const hidden_content_text = (notif, perpetual) => {
        let hidden_content = [];
        if (notif.hidden_game_count) {
            hidden_content.push(<b>{notif.hidden_game_count} primary example game{notif.hidden_game_count > 1 ? "s" : ""}</b>)
        }
        if (notif.hidden_secondary_game_count) {
            hidden_content.push(<b>{notif.hidden_secondary_game_count} secondary example game{notif.hidden_secondary_game_count > 1 ? "s" : ""}</b>)
        }
        if (notif.hidden_comment_count) {
            hidden_content.push(<b>{notif.hidden_comment_count} comment{notif.hidden_comment_count > 1 ? "s" : ""}</b>)
        }
        if (notif.hidden_pattern) {
            hidden_content.push(<b>the pattern itself</b>)
        }

        let hidden_content_text = "";
        if (hidden_content.length > 0) {
            hidden_content_text = <React.Fragment>
                {perpetual ? " has the following hidden content:" : "This hidden content includes"} {hidden_content.length === 1
                ? <>{hidden_content[0]}.</>
                : (hidden_content.length === 2 ? <>{hidden_content[0]} and {hidden_content[1]}.</>
                    : hidden_content.map((content, index) => {
                        if (index !== hidden_content.length - 1) {
                            return <React.Fragment key={index}>{content}, </React.Fragment>
                        } else {
                            return <React.Fragment key={index}>and {content}.</React.Fragment>
                        }
                    }))}
            </React.Fragment>
        }

        return hidden_content_text;
    }

    const hidden_content_notif_header = (notif) => {
        return <React.Fragment>Hidden Content: <b>{notif.length}</b> pattern{notif.length > 1 ? "s have" : " has"} hidden content</React.Fragment>
    }

    const hidden_content_notif_body = (notif) => {
        return <React.Fragment>
            Due to other users having unshared contact emails, there is content under patterns that you are the author
             of which is hidden to other users on the site. If you have a shared contact email, you can verify this
             content by liking it, which will make it visible.<br/><br/>
            <ul>
                {notif.map((pattern) => {
                    return <li style={{whiteSpace: "break-spaces", width: "100%"}} key={pattern.pattern_id}>
                        <Row style={{display: "inline-flex", width: "100%", alignItems: "center"}}>
                        <div className={"col-sm-10"} style={{whiteSpace: "break-spaces"}}><><b>{pattern.pattern_name}</b>{hidden_content_text(pattern, true)}</></div>
                        <div style={{textAlign: "right", fontSize: 14}} className={"col-sm-2"}>
                            <NavLink
                                to={'/PatternLibraryApp/PatternLibrary/' + pattern.pattern_id}
                                exact
                            >
                                <Button size="sm" style={{margin: 3}}
                                        className={classes.PatternLinkButton}>
                                    View Pattern
                                </Button>
                            </NavLink>
                        </div>
                        </Row>
                    </li>
                })}
            </ul>
        </React.Fragment>
    }

    const no_contact_email_notif_header = (notif) => {
        return <React.Fragment>No Contact Email: Your content is being hidden because you don't have a shared contact email</React.Fragment>
    }

    const no_contact_email_notif_body = (notif) => {
        return <React.Fragment>
            Some of the content you have contributed to the Pattern Library is hidden because you don't have a
            shared contact email. {no_contact_email_text(notif)} To make this content visible, you
             must enter and share a valid contact email.<br/>

            <Row style={{fontSize: 16, width: "100%", alignItems: "center", justifyContent: 'right', marginTop: 20}}>
                {/*<div className="col-sm-8"></div>*/}
                <div style={{width: 300, maxWidth: 300, marginLeft: 20}}>

                    Contact Email:
                    <Form.Control
                        style={{width: "100%"}}
                        type="text"
                        placeholder="Enter contact email"
                        value={contactEmail}
                        onChange={(event) => setContactEmail(event.target.value)}
                    />

                {/*<FormControlLabel*/}
                {/*    control={*/}
                <div style={{whiteSpace: "nowrap", width: "100%", display: "inline-flex", justifyContent: "left"}}>
                    <div style={{marginRight: 10}}>Share Contact Email:</div>
                    <Checkbox
                        disableRipple
                        style={{padding: 0}}
                        checked={(!!sharedContactEmail)}
                        onChange={(event) => {
                            setSharedContactEmail(sharedContactEmail ? 0 : 1)
                        }}
                        name="share_contact_email"
                        color="primary"
                    />
                </div>
                {/*}*/}
                {/*label="Display Contact Email"*/}
                {/*style={{marginTop: 5, paddingTop: 5}}*/}
                    {/*/>*/}

                    {/*{isLoading &&*/}
                    {/*    <Spinner*/}
                    {/*        animation="border"*/}
                    {/*        style={{width: 30, height: 30, float: "right", marginTop: 14, marginRight: 10}}*/}
                    {/*    />}*/}
            </div>
            </Row>
            <Button
                onClick={() => {
                    handleUpdateContactEmail()
                }}
                style={{
                    marginTop: 20,
                    marginBottom: 10,
                    marginRight: 10,
                    float: "right",
                    backgroundColor: "#003cb2",
                    border: "none"
                }}
            >
                Submit
            </Button>


            {/*<Row style={{padding: 10, fontSize: 16, justifyContent: "left", display: "inline-flex", alignItems: "center", maxWidth: "100%"}}>*/}
            {/*    <div className="col-xl-8" style={{display: "inline-flex", alignItems: "center", whiteSpace: "nowrap", marginBottom: 5}}>*/}
            {/*        Contact Email:*/}
            {/*        <Form.Control*/}
            {/*            style={{maxWidth: "75%", marginLeft: 10, width: 400}}*/}
            {/*            type="text"*/}
            {/*            placeholder="Enter contact email"*/}
            {/*            value={contactEmail}*/}
            {/*            onChange={(event) => setContactEmail(event.target.value)}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*    <FormControlLabel*/}
            {/*        control={*/}
            {/*    <div className="col-xl-4" style={{display: "inline-flex", alignItems: "center", whiteSpace: "nowrap",  marginBottom: 5}}>*/}
            {/*        Share Contact Email:*/}
            {/*        <Checkbox*/}
            {/*            disableRipple*/}
            {/*            style={{paddingBottom: 0, paddingTop: 0}}*/}
            {/*            checked={(!!sharedContactEmail)}*/}
            {/*            onChange={(event) => {*/}
            {/*                setSharedContactEmail(sharedContactEmail ? 0 : 1)*/}
            {/*            }}*/}
            {/*            name="share_contact_email"*/}
            {/*            color="primary"*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*    }*/}
            {/*    label="Display Contact Email"*/}
            {/*    style={{marginTop: 5, paddingTop: 5}}*/}
            {/*    />*/}

                {/*{isLoading &&*/}
                {/*    <Spinner*/}
                {/*        animation="border"*/}
                {/*        style={{width: 30, height: 30, float: "right", marginTop: 14, marginRight: 10}}*/}
                {/*    />}*/}
            {/*</Row>*/}
            {/*<Button*/}
            {/*    onClick={() => {*/}
            {/*        handleUpdateContactEmail()*/}
            {/*    }}*/}
            {/*    style={{*/}
            {/*        marginTop: 10,*/}
            {/*        marginBottom: 10,*/}
            {/*        marginRight: 10,*/}
            {/*        float: "right",*/}
            {/*        backgroundColor: "#003cb2",*/}
            {/*        border: "none"*/}
            {/*    }}*/}
            {/*>*/}
            {/*    Submit*/}
            {/*</Button>*/}
        </React.Fragment>
    }

    const no_contact_email_text = (notif) => {
        let no_contact_email_content = [];
        if (notif.hidden_pattern_count) {
            no_contact_email_content.push(<b>{notif.hidden_pattern_count} pattern{notif.hidden_pattern_count > 1 ? "s" : ""}</b>)
        }
        if (notif.hidden_game_count) {
            no_contact_email_content.push(<b>{notif.hidden_game_count} primary example
                game{notif.hidden_game_count > 1 ? "s" : ""}</b>)
        }
        if (notif.hidden_secondary_game_count) {
            no_contact_email_content.push(<b>{notif.hidden_secondary_game_count} secondary example
                game{notif.hidden_secondary_game_count > 1 ? "s" : ""}</b>)
        }
        if (notif.hidden_comment_count) {
            no_contact_email_content.push(
                <b>{notif.hidden_comment_count} comment{notif.hidden_comment_count > 1 ? "s" : ""}</b>)
        }

        let no_contact_email_content_text = "";
        if (no_contact_email_content.length > 0) {
            no_contact_email_content_text = <React.Fragment>
                This content includes {no_contact_email_content.length === 1 ? <>{no_contact_email_content[0]}.</>
                : (no_contact_email_content.length === 2 ? <>{no_contact_email_content[0]} and {no_contact_email_content[1]}.</>
                    : no_contact_email_content.map((content, index) => {
                        if (index !== no_contact_email_content.length - 1) {
                            return <React.Fragment  key={"no-contact-email-notif-" + index}>{content}, </React.Fragment>
                        } else {
                            return <React.Fragment  key={"no-contact-email-notif-" + index}>and {content}.</React.Fragment>
                        }
                    }))
            }

            </React.Fragment>
        }
        return no_contact_email_content_text;
    }

    const merge_notif_header = (notif) => {
        return <>Merge: <b>{notif.display_name}</b> merged your pattern <b>{notif.additional_pattern_name_2}</b> with their pattern <b>{notif.additional_pattern_name_1}</b></>
    }

    const merge_notif_body = (notif) => {
        return <>
            Your pattern <b>{notif.additional_pattern_name_2}</b> has been merged with <b>{notif.additional_pattern_name_1}:</b>
            <ul>
                <li>You are now a co-author of the new pattern <b>{notif.pattern_name}</b> and can edit it if needed to improve the quality of the merge.</li>
                <li><b>{notif.display_name}</b> left a comment on your pattern explaining the reason for the merge.</li>
                <li>Your pattern has been moved to the merge state and will show up at the end of the search results.</li>
                <li>If you disagree with this merge you may move your pattern out of the merge status.</li>
            </ul>
        </>
    }

    const notifs_jsx = () => {
        let no_contact_email_content_notif_jsx = ""
        let hidden_content_notif_jsx = ""
        let notification_jsx = ""
        if (state_notifications.hidden_content && state_notifications.hidden_content.length > 0) {
            hidden_content_notif_jsx = notification_accordion_jsx({}, hidden_content_notif_body(state_notifications.hidden_content), hidden_content_notif_header(state_notifications.hidden_content), "hidden")
        }
        if (state_notifications.no_contact_email_content) {
            no_contact_email_content_notif_jsx = notification_accordion_jsx({}, no_contact_email_notif_body(state_notifications.no_contact_email_content), no_contact_email_notif_header(state_notifications.no_contact_email_content), "no-contact")
        }
        if (notifications.length > 0) {
            let notifs = notifications.sort(function (x, y) {
                return new Date(y.created_timestamp) - new Date(x.created_timestamp);
            })
            // console.log(notifs)
            notification_jsx = notifs.map((notif, index) => {
                let notif_header = '';
                let notif_body = '';
                switch (notif.element_type) {
                    case 'PRIMARY_GAME':
                        notif_header = primary_notif_header(notif)
                        notif_body = primary_notif_body(notif)
                        break;
                    case 'SECONDARY_GAME':
                        notif_header = secondary_notif_header(notif)
                        notif_body = secondary_notif_body(notif)
                        break;
                    case 'COMMENT':
                        notif_header = comment_notif_header(notif)
                        notif_body = comment_notif_body(notif)
                        break;
                    case 'RATING':
                        notif_header = rating_notif_header(notif)
                        notif_body = rating_notif_body(notif)
                        break;
                    case 'MERGE':
                        notif_header = merge_notif_header(notif)
                        notif_body = merge_notif_body(notif)
                        break;
                    case 'HIDDEN_CONTENT':
                        notif_header = hidden_content_notif_header(notif)
                        notif_body = hidden_content_notif_body(notif)
                        break;
                    case 'NO_CONTACT_EMAIL':
                        notif_header = no_contact_email_notif_header(notif)
                        notif_body = no_contact_email_notif_body(notif)
                        break;
                    default:
                        break;
                }

                return notification_accordion_jsx(notif, notif_body, notif_header, index)

            })
        }

        return <>{no_contact_email_content_notif_jsx}{hidden_content_notif_jsx}{notification_jsx}</>
    }

    const notification_accordion_jsx = (notif, notif_body, notif_header, index) => {
        return <div className={"col-sm-12 " + classes.NotificationAccordion} key={"notification-" + index}>
            <div >
                {notif.created_timestamp ?
                    notif.hasBeenViewed
                        ? <div className={classes.NotificationCircleViewed}/>
                        : <div className={classes.NotificationCircle}/>
                    : <div style={{
                        height: 28,
                        width: 28,
                        alignItems: "center",
                        justifyContent: "center",
                        display: "inline-flex",
                        top: 0
                    }}><PriorityHigh style={{color: "#980000"}}/></div>}
            </div>
            <div style={{marginBottom: 5, justifyContent: "right", width: "100%", minWidth: '50%', border: "none"}}>
                <Accordion defaultActiveKey="1">
                <div className="card" style={{border: "1px solid #808080", margin: "0px",}}>
                        <AccordionToggle eventKey="0" className={classes.NotificationHeader}
                                         onClick={() => {
                                             handleViewNotification(notif)
                                             if (index === "no-contact") {
                                                 handleUserContactEmailInfo()
                                             }
                                         }}>
                                    <span style={{
                                        display: "inline-flex",
                                        justifyContent: 'space-between',
                                        width: "100%"
                                    }}>
                                        <div className={classes.NotificationDiv}>{notif_header}</div>
                                        <div style={{
                                            minWidth: 75,
                                            textAlign: "right"
                                        }}>{notif.created_timestamp ? formatDate(notif.created_timestamp) : ''}</div>
                                    </span>
                        </AccordionToggle>
                        <AccordionCollapse eventKey="0" className={classes.NotificationContents}>
                            <div className="card-body" style={{padding: 0}}>
                                <React.Fragment>
                                    <div style={{textAlign: "left", fontSize: 14, padding: 3}}>
                                        {notif_body}
                                    </div>
                                    {notif.pattern_id
                                        ? <div style={{textAlign: "right", fontSize: 14}}>
                                            <NavLink
                                                to={'/PatternLibraryApp/PatternLibrary/' + notif.pattern_id}
                                                exact
                                            >
                                                <Button size="sm" style={{margin: 3}}
                                                        className={classes.PatternLinkButton}>
                                                    View Pattern
                                                </Button>
                                            </NavLink>
                                        </div>
                                        : ""}
                                </React.Fragment>
                            </div>
                        </AccordionCollapse>
                    </div>
                </Accordion>
            </div>
        </div>
    }

    const unreadNotificationCount = () => {
        const unreadNotifications = notifications.filter((notif) => {
            return !notif.hasBeenViewed
        })
        const perpetualNotificationCount =
            (state_notifications.hidden_content && state_notifications.hidden_content.length > 0 ? 1 : 0)
            + (state_notifications.no_contact_email_content ? 1 : 0)
        if (unreadNotifications) {
            return (unreadNotifications.length || 0) + perpetualNotificationCount
        } else {
            return 0 + perpetualNotificationCount
        }
    }


    return <React.Fragment>
        <div className={"card"} style={{width: "100%"}}>
            <div className={"card-header"}>
                <Row>
                    <div className="col-sm-3"/>
                    <div className="col-sm-6" style={{fontSize: 24}}>
                        <b>{unreadNotificationCount() === 0 ? '' : unreadNotificationCount() + " Unread "}Notification{unreadNotificationCount() === 1 ? "" : "s"}</b>
                    </div>
                    <div className="col-sm-3" style={{padding: 3}}>
                        <Button
                            size="sm"
                            className="preset-modal-button-button"
                            onClick={() => handleViewAllNotifications()}
                            style={{
                                background: unreadNotificationCount() === 0 ? "grey" : "#003cb2",
                                borderColor: unreadNotificationCount() === 0 ? "grey" : "#003cb2"
                            }}
                            disabled={unreadNotificationCount() === 0}
                        >
                            Mark as Read
                        </Button>
                    </div>
                </Row>
            </div>
            <div className={"card-body"}
                 style={{overflowY: "scroll", overflowX: "hidden", maxHeight: "400px", alignItems: "center"}}>
                {notifs_jsx()}
            </div>
        </div>
    </React.Fragment>

}